export const MEDIA_TYPE_VIDEO = 'video'

export const NEW_DESIGN_VIDEO_URL =
  'https://www.youtube.com/watch?v=wSpQMG25zYA&feature=youtu.be&ab_channel=Chatterbug'

export const LL_INTRODUCTION_VIDEO_URL =
  'https://home.wistia.com/medias/fjivwrdfo9'

export const VIDEO_SIZE = {
  width: 640,
  height: 360,
}
